import { API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_TOP_SUCCESS, CLEAR_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS, HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE, HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS, SET_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_UPLOAD_GROUP_ID, SET_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS, SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE, SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS, UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS, UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS, UPDATE_REMOVE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS, } from '../actions/ProffitSearchInformationTopAction';
import { API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUMMARY_SUCCESS } from '../actions/ProffitSearchSummaryAction';
const INITIAL_STATE = {
    currentUploadGroupId: null,
    information: null,
    modalInformation: {
        addAllTagsCount: null,
        pageCount: null,
        progress: 0,
        progressModalId: null,
        showCompleteModal: false,
        showProgressModal: false,
        tagSetPageCount: null,
    },
    summary: {
        adminFileCount: null,
        comparedToLastWeekSlideCount: null,
        myFileCount: null,
        tags: null,
    },
    uploadItems: [],
};
const updateCalcProgressFunc = (state) => {
    const { modalInformation: { progressModalId }, uploadItems, } = state;
    let progress = 0;
    uploadItems
        .filter((v) => v.modalId === progressModalId)
        .forEach((v) => {
        progress += v.progress;
    });
    return Object.assign(Object.assign({}, state), { modalInformation: Object.assign(Object.assign({}, state.modalInformation), { progress }) });
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { payload, type }) => {
    switch (type) {
        case API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_TOP_SUCCESS: {
            // 情報取得
            return Object.assign(Object.assign({}, state), { information: payload, summary: Object.assign(Object.assign({}, state.summary), { adminFileCount: payload.adminFileCount, comparedToLastWeekSlideCount: payload.comparedToLastWeekSlideCount, myFileCount: payload.myFileCount }) });
        }
        case API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUMMARY_SUCCESS: {
            // 統計用のデータのみを更新
            return Object.assign(Object.assign({}, state), { summary: Object.assign(Object.assign({}, state.summary), payload) });
        }
        case SET_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_UPLOAD_GROUP_ID: {
            // currentUploadGroupIdの設定
            return Object.assign(Object.assign({}, state), { currentUploadGroupId: payload.currentUploadGroupId });
        }
        case SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS: {
            // 進捗モーダルの表示
            return updateCalcProgressFunc(Object.assign(Object.assign({}, state), { currentUploadGroupId: null, modalInformation: Object.assign(Object.assign(Object.assign({}, INITIAL_STATE.modalInformation), state.modalInformation), { progressModalId: payload.modalId, showProgressModal: true }), uploadItems: [...state.uploadItems, ...payload.addItems] }));
        }
        case HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS: {
            // 進捗モーダルの非表示
            if (payload.isForce ||
                payload.modalId === state.modalInformation.progressModalId) {
                return Object.assign(Object.assign({}, state), { currentUploadGroupId: null, modalInformation: Object.assign(Object.assign({}, state.modalInformation), { showProgressModal: false }) });
            }
            return state;
        }
        case SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE: {
            // 完了モーダルの表示
            return Object.assign(Object.assign({}, state), { modalInformation: Object.assign(Object.assign(Object.assign({}, state.modalInformation), payload.modalInformation), { showCompleteModal: true, showProgressModal: false }) });
        }
        case HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE: {
            // 完了モーダルの非表示
            return Object.assign(Object.assign({}, state), { modalInformation: Object.assign(Object.assign({}, state.modalInformation), { showCompleteModal: false }) });
        }
        case UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS: {
            // アップロード進捗モーダル内で参照するスライドを設定
            const stateCurrentUploadGroupId = state.modalInformation.currentUploadGroupId;
            const stateModalId = state.modalInformation.progressModalId;
            const payloadCurrentUploadGroupId = payload.currentUploadGroupId;
            const payloadModalId = payload.modalId;
            const isEqualUploadSlideGroupId = payloadCurrentUploadGroupId &&
                payloadCurrentUploadGroupId === stateCurrentUploadGroupId;
            const isEqualModalId = payloadModalId && stateModalId === payloadModalId;
            if (!isEqualUploadSlideGroupId && !isEqualModalId) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { modalInformation: Object.assign(Object.assign({}, state.modalInformation), payload.modalInformation) });
        }
        case SET_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS: {
            return updateCalcProgressFunc(Object.assign(Object.assign({}, state), { uploadItems: [...payload.items] }));
        }
        case UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS: {
            const { updateItemSettings } = payload;
            const newUploadItems = state.uploadItems.map((uploadItem) => {
                const updateItemSetting = updateItemSettings.find((v) => v.itemId === uploadItem.itemId);
                if (updateItemSetting) {
                    return Object.assign(Object.assign({}, uploadItem), updateItemSetting);
                }
                return uploadItem;
            });
            return updateCalcProgressFunc(Object.assign(Object.assign({}, state), { uploadItems: newUploadItems }));
        }
        case UPDATE_REMOVE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS: {
            const { updateItemSettings } = payload;
            return updateCalcProgressFunc(Object.assign(Object.assign({}, state), { uploadItems: state.uploadItems.filter((uploadItem) => !!updateItemSettings.find((v) => v.itemId !== uploadItem.itemId)) }));
        }
        case CLEAR_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS: {
            return updateCalcProgressFunc(Object.assign(Object.assign({}, state), { uploadItems: [] }));
        }
        default: {
            return state;
        }
    }
};
